<section class="vc-admin-business-categories">
  <header class="vc-admin-business-categories__header">
    <h3>{{ 'ADMIN.BUSINESS_CATEGORIES.TITLE' | translate }}</h3>
    <p>{{ 'ADMIN.BUSINESS_CATEGORIES.DESCRIPTION' | translate }}</p>
  </header>

  <section class="vc-admin-business-categories__create">
    <div class="vc-admin-business-categories__create-head">
      <h4>{{ 'ADMIN.BUSINESS_CATEGORIES.CREATE_TITLE' | translate }}</h4>
      <p>{{ 'ADMIN.BUSINESS_CATEGORIES.CREATE_DESCRIPTION' | translate }}</p>
    </div>
    <div class="vc-admin-business-categories__create-form">
      <label for="newCategoryName">{{ 'ADMIN.BUSINESS_CATEGORIES.NAME' | translate }}</label>
      <input
        id="newCategoryName"
        pInputText
        [(ngModel)]="newCategoryName"
        [placeholder]="'ADMIN.BUSINESS_CATEGORIES.NAME_PLACEHOLDER' | translate"
      />
      <button pButton type="button" icon="pi pi-plus" (click)="create()" [disabled]="saving">
        {{ 'COMMON.CREATE' | translate }}
      </button>
    </div>
  </section>

  @if (loading) {
    <p class="vc-admin-business-categories__state">{{ 'COMMON.LOADING' | translate }}</p>
  } @else if (!rows.length) {
    <p class="vc-admin-business-categories__state">{{ 'COMMON.NO_DATA' | translate }}</p>
  } @else {
    <p-table [value]="rows" responsiveLayout="scroll">
      <ng-template pTemplate="header">
        <tr>
          <th>{{ 'ADMIN.BUSINESS_CATEGORIES.NAME' | translate }}</th>
          <th>{{ 'ADMIN.BUSINESS_CATEGORIES.CODE' | translate }}</th>
          <th>{{ 'COMMON.ACTIVE' | translate }}</th>
          <th>{{ 'COMMON.ACTIONS' | translate }}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-row>
        <tr>
          <td>
            @if (row._editing) {
              <input pInputText [(ngModel)]="row._draftName" />
            } @else {
              {{ row.name }}
            }
          </td>
          <td><code>{{ row.code || '-' }}</code></td>
          <td>
            @if (row._editing) {
              <input type="checkbox" [(ngModel)]="row._draftActive" />
            } @else {
              {{ (row.active ? 'COMMON.YES' : 'COMMON.NO') | translate }}
            }
          </td>
          <td class="vc-admin-business-categories__actions">
            @if (row._editing) {
              <button pButton type="button" size="small" (click)="saveRow(row)" [disabled]="saving">
                {{ 'COMMON.SAVE' | translate }}
              </button>
              <button
                pButton
                type="button"
                size="small"
                severity="secondary"
                (click)="cancelEdit(row)"
                [disabled]="saving"
              >
                {{ 'COMMON.CANCEL' | translate }}
              </button>
            } @else {
              <button pButton type="button" size="small" (click)="startEdit(row)">
                {{ 'COMMON.EDIT' | translate }}
              </button>
              <button
                pButton
                type="button"
                size="small"
                severity="danger"
                (click)="disable(row)"
                [disabled]="saving || row.is_system"
              >
                {{ 'COMMON.DISABLE' | translate }}
              </button>
            }
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
</section>
